import { Box } from '@material-ui/core'
import axios from 'axios'
import * as HttpStatus from 'http-status-codes'
import { useState } from 'react'
import { useHistory } from 'react-router'
import { SimpleDialog } from 'shared/components/Dialog/SimpleDialog'
import { Handler } from 'shared/helpers/typeHelper'

import { Button } from '../../components/Button/Button'
import { useUserProvider } from '../../components/Context/UserContext'
import { Dropdown } from '../../components/Dropdown/Dropdown'
import { Text } from '../../components/Text/Text'
import { TextInput } from '../../components/TextInput/TextInput'
import { primaryBlack } from '../../theme/colors'

const GENERIC_ISSUE_TYPE_OPTIONS = [
  { label: 'Job payment', value: 'PAYMENT' },
  { label: 'Pickup pay', value: 'CASH_ADVANCE' },
  { label: 'Other payment inquiry', value: 'OTHER_PAYMENT' },
  { label: 'Safety & compliance', value: 'SAFETY_COMPLIANCE' },
  { label: 'Direct shipper loads', value: 'SHIPPER_LOADS' },
  { label: 'Trailers', value: 'TRAILERS' },
  { label: 'Something else', value: 'OTHER' },
]

interface CreateIssueButtonProps {
  userId: string
  refetch: Handler
}

export function CreateIssueButton({ userId, refetch }: CreateIssueButtonProps) {
  const [showCreateModal, setshowCreateModal] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { showBanner } = useUserProvider()
  const [issueType, setIssueType] = useState<string | undefined>(undefined)
  const [description, setDescription] = useState<string>('')
  const [note, setNote] = useState<string>('')
  const history = useHistory()

  const handleClose = () => {
    setshowCreateModal(false)
    setIssueType(undefined)
    setDescription('')
    setNote('')
    setIsLoading(false)
  }

  const saveIssue = async () => {
    setIsLoading(true)

    try {
      const data = {
        reported_for: userId,
        type: issueType,
        description,
        notes: note,
      }
      const response = await axios.post('/api/v3/issues/report/', data)
      if (response.status !== HttpStatus.CREATED) {
        throw new Error('Failed to create issue')
      }
      await Promise.all([refetch()])
      const issueId = response.data.id
      history.push(`/generic-issues/${issueId}/show`)
    } catch (err: any) {
      const error = err?.response?.data || err?.data || err?.message || err || {}
      showBanner('error', { message: `Something went wrong. ${error}` })
    } finally {
      handleClose()
    }
  }

  return (
    <>
      <Box>
        <Button variant="secondary" size="medium" onClick={() => setshowCreateModal(true)}>
          Create Issue
        </Button>
      </Box>
      <SimpleDialog isOpen={showCreateModal} onClose={handleClose} size="medium" alignText="left">
        <div style={{ width: '100%' }}>
          <Text variant="header2" fontColor={primaryBlack}>
            Create Generic Issue
          </Text>
          <Text variant="paragraph2" fontColor={primaryBlack}>
            (If you'd like to create a job-related issue, visit the job's issue tab)
          </Text>
        </div>
        <Box mt={3} />
        <Dropdown
          options={GENERIC_ISSUE_TYPE_OPTIONS}
          label="Type"
          value={issueType}
          onChange={(value) => setIssueType(value)}
        />
        <TextInput
          placeholder="Description (driver visible)"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
        <TextInput
          placeholder="Internal Note (optional)"
          value={note}
          onChange={(e) => setNote(e.target.value)}
        />

        <Box mt={5} />
        <Button
          type="submit"
          margin="0 auto"
          onClick={saveIssue}
          variant="primary"
          size="large"
          isLoading={isLoading}
          isDisabled={!issueType || !description}
        >
          Create
        </Button>
        <Box mt={3} />
        <Button variant="text" margin="0 auto" onClick={handleClose}>
          Cancel
        </Button>
      </SimpleDialog>
    </>
  )
}
